import React, { useState, useEffect, useContext } from "react";
import {
  Paper,
  Typography,
  Box,
  CircularProgress,
  LinearProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";
import { DiskCleanupForm } from "../DiskCleanupModal";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  usageBar: {
    marginTop: theme.spacing(1),
    height: 10,
    borderRadius: 5,
  },
  infoText: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
}));

const DiskCleanupSettings = () => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const [diskUsage, setDiskUsage] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchDiskUsage = async () => {
    if (!user?.companyId) {
      return;
    }

    setLoading(true);
    try {
      const { data } = await api.get(`/companies/${user.companyId}/disk-usage`);
      setDiskUsage(data);
    } catch (error) {
      setDiskUsage(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDiskUsage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.companyId]);

  if (!user?.companyId) {
    return null;
  }

  return (
    <Box>
      <Paper className={classes.paper} elevation={1}>
        <Typography variant="h6" gutterBottom>
          Limpeza de Disco
        </Typography>
        <Typography variant="body2" className={classes.infoText}>
          Execute a limpeza manualmente a qualquer momento para liberar espaço. Selecione
          os tipos de arquivo e o período de retenção desejados.
        </Typography>

        {loading ? (
          <Box display="flex" justifyContent="center" py={2}>
            <CircularProgress size={28} />
          </Box>
        ) : (
          diskUsage && (
            <Box mb={2}>
              <Typography variant="body2">
                Uso atual: <strong>{diskUsage.formattedDiskUsage}</strong> de{" "}
                <strong>{diskUsage.formattedDiskQuota}</strong> ({diskUsage.percentage}%)
              </Typography>
              {diskUsage.diskQuota > 0 && (
                <LinearProgress
                  variant="determinate"
                  value={Math.min(diskUsage.percentage || 0, 100)}
                  className={classes.usageBar}
                  color={
                    diskUsage.percentage >= 100
                      ? "secondary"
                      : diskUsage.percentage >= 90
                      ? "primary"
                      : "primary"
                  }
                />
              )}
            </Box>
          )
        )}
      </Paper>

      <Paper className={classes.paper} elevation={1}>
        <DiskCleanupForm
          companyId={user.companyId}
          diskUsage={diskUsage}
          embedded
          onStarted={() => fetchDiskUsage()}
        />
      </Paper>
    </Box>
  );
};

export default DiskCleanupSettings;
